import React from 'react';

const PaymentGooglePay = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="15"
      viewBox="0 0 38 15"
      fill="none"
    >
      <path
        d="M17.6774 7.16199V11.458H16.2754V0.833496H19.9207C20.8087 0.833496 21.6499 1.15685 22.3042 1.75736C22.9585 2.31168 23.2857 3.14317 23.2857 4.02084C23.2857 4.89851 22.9585 5.6838 22.3042 6.28432C21.6499 6.88483 20.8554 7.20818 19.9207 7.20818L17.6774 7.16199ZM17.6774 2.12691V5.82238H20.0142C20.5283 5.82238 21.0424 5.63761 21.3695 5.26806C22.1173 4.57516 22.1173 3.42033 21.4163 2.72743L21.3695 2.68123C20.9956 2.31168 20.5283 2.08072 20.0142 2.12691H17.6774Z"
        fill="#5F6368"
      />
      <path
        d="M26.5104 3.97583C27.5385 3.97583 28.333 4.25299 28.9406 4.80731C29.5482 5.36163 29.8286 6.10073 29.8286 7.02459V11.4592H28.52V10.4429H28.4732C27.9124 11.2744 27.1179 11.6901 26.1832 11.6901C25.3887 11.6901 24.6877 11.4592 24.1269 10.9972C23.6128 10.5353 23.2856 9.88859 23.2856 9.19568C23.2856 8.45659 23.5661 7.85608 24.1269 7.39414C24.6877 6.93221 25.4822 6.74743 26.4169 6.74743C27.2581 6.74743 27.9124 6.88601 28.4265 7.20937V6.88601C28.4265 6.42408 28.2396 5.96215 27.8657 5.68499C27.4918 5.36163 27.0245 5.17686 26.5104 5.17686C25.7159 5.17686 25.1083 5.50021 24.6877 6.14692L23.4726 5.40783C24.2203 4.43776 25.2018 3.97583 26.5104 3.97583ZM24.7344 9.24188C24.7344 9.61143 24.9214 9.93478 25.2018 10.1196C25.5289 10.3505 25.9028 10.4891 26.2767 10.4891C26.8375 10.4891 27.3983 10.2581 27.819 9.84239C28.2863 9.42665 28.52 8.91852 28.52 8.3642C28.0994 8.04085 27.4918 7.85608 26.6973 7.85608C26.1365 7.85608 25.6691 7.99466 25.2953 8.27182C24.9214 8.50278 24.7344 8.82614 24.7344 9.24188Z"
        fill="#5F6368"
      />
      <path
        d="M37.3999 4.20648L32.7731 14.6924H31.3711L33.1003 11.0431L30.0625 4.25268H31.558L33.7546 9.47253H33.8013L35.9511 4.25268H37.3999V4.20648Z"
        fill="#5F6368"
      />
      <path
        d="M12.116 6.23917C12.116 5.82342 12.0693 5.40768 12.0226 4.99194H6.18066V7.34781H9.49886C9.35865 8.0869 8.93804 8.7798 8.28375 9.19554V10.7199H10.2934C11.4617 9.65748 12.116 8.0869 12.116 6.23917Z"
        fill="#4285F4"
      />
      <path
        d="M6.18076 12.1978C7.86323 12.1978 9.26528 11.6434 10.2935 10.7196L8.28384 9.19519C7.72302 9.56474 7.02199 9.7957 6.18076 9.7957C4.59177 9.7957 3.18971 8.73325 2.72236 7.25507H0.666016V8.82564C1.74092 10.9043 3.84401 12.1978 6.18076 12.1978Z"
        fill="#34A853"
      />
      <path
        d="M2.72318 7.2553C2.44268 6.5162 2.44268 5.68472 2.72318 4.89943V3.32886H0.666185C-0.222062 5.03801 -0.222062 7.07052 0.666185 8.82587L2.72318 7.2553Z"
        fill="#FBBC04"
      />
      <path
        d="M6.1809 2.40454C7.06887 2.40454 7.9101 2.7279 8.56439 3.32841L10.3403 1.57306C9.21869 0.556806 7.72316 -0.0437081 6.22764 0.00248527C3.89088 0.00248527 1.74106 1.2959 0.712891 3.3746L2.76924 4.94518C3.18985 3.46699 4.59191 2.40454 6.1809 2.40454Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default PaymentGooglePay;
